/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_FlavorInputs */

const en_add_flavor = /** @type {(inputs: Add_FlavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Flavor`)
};

const es_add_flavor = /** @type {(inputs: Add_FlavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar sabor`)
};

/**
* | output |
* | --- |
* | "Add Flavor" |
*
* @param {Add_FlavorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const add_flavor = /** @type {((inputs?: Add_FlavorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_FlavorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_flavor(inputs)
	return es_add_flavor(inputs)
});